import React, { useState, useEffect } from 'react'
import { Dropdown, DropdownToggle, DropdownMenu } from 'reactstrap'
import callAPI from '../../../helpers/callAPI'

export default function AdminRolePicker({
    record,
    passedRoles,
    selectRole,
    selectedRoles,
    showSystemMessage,
}) {
    const [dataLoaded, setDataLoaded] = useState(false)
    const [roles, setRoles] = useState(passedRoles ? passedRoles : false)
    const [dropdownOpen, setDropdownOpen] = useState(false)

    const toggle = () => setDropdownOpen((prev) => !prev)

    useEffect(() => {
        const fetchRoles = async () => {
            if (!roles) {
                try {
                    const result = await callAPI('authorization/roles', 'GET')

                    if (result['success'] === true) {
                        setRoles(result.roles)
                    } else if (result['success'] === false) {
                        showSystemMessage('error', result.errors.message)
                    }
                } catch (error) {
                    showSystemMessage('error', error.message)
                }
            }

            setDataLoaded(true)
        }

        fetchRoles()
    }, [roles, showSystemMessage])

    const handleToggleRole = (roleId) => {
        const idStr = String(roleId)

        selectRole((prev) => {
            const current = prev || []
            if (current.includes(idStr)) {
                return current.filter((id) => id !== idStr)
            }
            return [...current, idStr]
        })
    }

    const selectedCount = selectedRoles ? selectedRoles.length : 0
    const toggleLabel =
        selectedCount === 0
            ? 'Select role(s)...'
            : selectedCount === 1
                ? '1 role selected'
                : `${selectedCount} roles selected`

    const availableRoles =
        dataLoaded && roles
            ? roles.filter(
                (role) =>
                    record.roles.findIndex((element) => element.name == role.role) < 0
            )
            : []

    return (
        <Dropdown isOpen={dropdownOpen} toggle={toggle}>
            <DropdownToggle
                caret
                size="sm"
                color="light"
                className="form-control form-control-sm w-100 d-flex justify-content-between align-items-center border"
            >
                <span className="text-truncate mr-2">{toggleLabel}</span>
            </DropdownToggle>

            <DropdownMenu
                className="w-200"
                style={{ maxHeight: '300px', overflowY: 'auto' }}
            >
                {availableRoles.length === 0 && (
                    <div className="dropdown-item text-muted">No roles available</div>
                )}

                {availableRoles.map((role) => {
                    const idStr = String(role.role_id)
                    const checked =
                        selectedRoles && selectedRoles.includes(idStr)

                    const inputId = `role-${record.id}-${role.role_id}`

                    return (
                        <div key={role.role_id} className="dropdown-item">
                            <div className="custom-control custom-checkbox">
                                <input
                                    type="checkbox"
                                    className="custom-control-input"
                                    id={inputId}
                                    checked={checked}
                                    onChange={() => handleToggleRole(role.role_id)}
                                />
                                <label
                                    className="custom-control-label"
                                    htmlFor={inputId}
                                >
                                    {role.role}
                                </label>
                            </div>
                        </div>
                    )
                })}
            </DropdownMenu>
        </Dropdown>
    )
}
